module.exports = __webpack_public_path__ + "static/img/icon-insurance-10.51cf4247.png";